import React, { Component, Fragment } from 'react'
import logo from './../data-broker-logo-white.gif';
import QuoteText from '../components/quotetext.js';
import CompleteSection from '../components/completesection.js';
import LoadingSection from '../components/loadingsection.js';
import StepIndicator from '../components/stepindicator.js';
import Step from '../steps/step.js';
import Step1 from '../steps/step1.js';
import Step2 from '../steps/step2.js';
import Step3 from '../steps/step3.js'
import { withUserAgent } from "react-useragent";
import { FormValidation, Form } from 'calidation'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-21043366-1');
// ReactGA.pageview(window.location.pathname);


class MasterForm extends Component {
  constructor(props) {
    super(props)

    const { stepData } = this.props

    // Set the initial input values
    this.state = {
      currentStep: 1,
      maxSteps: this.props.stepData.length,
      stepData: stepData,
      selectedChoices: {},
      personalDetails: {},
      choiceMade: false,
      complete: false,
      completing: false,
      recaptchaComplete: false,
      additionalNotes: "",
    }
    // Bind the submission to handleChange()
    this.handleChange = this.handleChange.bind(this)
    this.handleSliderChange = this.handleSliderChange.bind(this)
    this._next = this._next.bind(this)
    this._prev = this._prev.bind(this)
    this._submit = this._submit.bind(this)
    this.updateNotes = this.updateNotes.bind(this)
    this.stepChange = this.stepChange.bind(this)
    this.getRefQueryParam = this.getRefQueryParam.bind(this)
    this.recaptcaChange = this.recaptcaChange.bind(this)
  }

  recaptcaChange() {
    this.setState({
      recaptchaComplete: true
    })
  }

  // Use the submitted data to set the state
  stepChange(selectedStep) {
    this.setState({
      currentStep: Number(selectedStep)
    })
  }

  handleChange(selectedChoices) {
    let updatedChoices = Object.assign({}, this.state.selectedChoices)

    let newStepData = [...this.state.stepData];
    newStepData[(this.state.currentStep-1)]['selectedChoices'] = selectedChoices
    this.setState({stepData: newStepData})

    if(selectedChoices.length != 0) {
      updatedChoices[this.state.currentStep-1] = selectedChoices
    } else {
      delete updatedChoices[this.state.currentStep-1]
    }

    console.log("updatedChoices");
    console.log(updatedChoices);


    this.setState({
      selectedChoices: updatedChoices,
    })

    if(!this.state.choiceMade) {
      this.setState({
        choiceMade: (selectedChoices.length != 0) ? true : false,
      })
    }
  }

  handleSliderChange(sliderData, unsure) {
    let updatedChoices = Object.assign({}, this.state.selectedChoices);

    let newStepData = [...this.state.stepData];
    newStepData[(this.state.currentStep-1)]['selectedChoices'] = `£${sliderData[0]} - ${sliderData[1]}`
    this.setState({stepData: newStepData})

    if(!unsure) {
      updatedChoices[this.state.currentStep-1] = sliderData
    } else {
      delete updatedChoices[this.state.currentStep-1]
    }



    this.setState({
      selectedChoices: updatedChoices,
      choiceMade: true,
    })
  }

  // Trigger an alert on form submission
  handleSubmit = (event) => {
    event.preventDefault()
    const { email, username, password } = this.state
    alert(`Your registration detail: \n
      Email: ${email} \n
      Username: ${username} \n
      Password: ${password}`)
  }

  // Test current step with ternary
  // _next and _previous functions will be called on button click
  _next() {
    let currentStep = this.state.currentStep
    let maxSteps = this.state.maxSteps
    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= (maxSteps-1) ? maxSteps : currentStep + 1
    this.setState({
      currentStep: currentStep
    })
  }

  _prev() {
    let currentStep = this.state.currentStep
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep <= 1? 1: currentStep - 1
    this.setState({
      currentStep: currentStep
    })
  }

  _submit({ fields, errors, isValid }) {
    // e.preventDefault()
    console.log("Submit");
    console.log({ fields, errors, isValid });

    if(isValid) {
      let quoteText = document.getElementById("quoteText").innerText
      let personalDetails

      Object
      .keys(this.state.personalDetails)
      .map( (key) => {
        personalDetails = `${(personalDetails) ? personalDetails : ''}<strong>${key}</strong>: ${this.state.personalDetails[key]}<br/>`
      })


      this.setState({
        completing: true
      })

      // alert("!")

      var xhr = new XMLHttpRequest()

      xhr.addEventListener('load', (e) => {
        ReactGA.ga('send', 'event', 'form', 'submission')

        window.TriggerBingUETEvent( 'submission', 'form', 'contact_form');
        window.CreateLinkedInPixelImage(1838033);

        // console.log(response);

        let emailTitle = ""

        if(e.currentTarget.status < 400) {
          emailTitle = "Quote Request"
          console.log('success');
        } else {
          emailTitle = "*CRM import error* - Quote Request"
          console.log('http error');
        }


        window.emailjs.send('mailgun_databroker', 'databroker_quote', {
          emailTitle: emailTitle,
          personalDetails: personalDetails,
          additionalNotes: this.state.additionalNotes,
          quoteText: quoteText,
          browserData: JSON.stringify(this.props.ua),
          rawData: JSON.stringify(this.state.personalDetails)
        })

        this.setState({
          complete: true
        })
      })

      xhr.addEventListener("error", function(e) {
        console.log('error');

        let emailTitle = "*CRM import error* - Quote Request"

        window.emailjs.send('mailgun_databroker', 'databroker_quote', {
          emailTitle: emailTitle,
          personalDetails: personalDetails,
          additionalNotes: this.state.additionalNotes,
          quoteText: quoteText,
          browserData: JSON.stringify(this.props.ua),
          rawData: JSON.stringify(this.state.personalDetails)
        })

        this.setState({
          complete: true
        })
      }, false);

      // xhr.open('POST', '//localhost:3001/zohoPush.php')
      xhr.open('POST', '//www.data-broker.co.uk/zohoPush.php')

      let zohoData = {}
      zohoData['First_Name'] = this.state.personalDetails['First Name'];
      zohoData['Last_Name'] = this.state.personalDetails['Last Name'];
      zohoData['Email'] = this.state.personalDetails['Email'];
      zohoData['Phone'] = this.state.personalDetails['Contact Number'];
      zohoData['Company'] = this.state.personalDetails['Company'];
      Object
      .keys(this.state.stepData)
      .map( (key, index) => {
        if(this.state.stepData[index]['selectedChoices']) {
          if(this.state.stepData[index]['label'] === "Industry") {
            zohoData[ 'Industry_Sector' ] = this.state.stepData[index]['selectedChoices'];

          } else if(this.state.stepData[index]['label'] === "Job Function") {
            zohoData[ 'Job_Function1' ] = this.state.stepData[index]['selectedChoices'];

          } else if(this.state.stepData[index]['label'] === "Size Of Company") {
            zohoData[ 'Company_Size1' ] = this.state.stepData[index]['selectedChoices'];

          } else {
            zohoData[ this.state.stepData[index]['label'] ] = this.state.stepData[index]['selectedChoices'];

          }

        }
      })


      zohoData['Additional_Count_Info'] = this.state.additionalNotes;
      zohoData['Quote_Sentence'] = quoteText;
      zohoData['GaContent'] = document.getElementById('GaContent').value;
      zohoData['GaReferURL'] = document.getElementById('GaReferURL').value;
      zohoData['GaMedium'] = document.getElementById('GaMedium').value;
      zohoData['GaSource'] = document.getElementById('GaSource').value;
      zohoData['GaTerm'] = document.getElementById('GaTerm').value;
      zohoData['GaCampaign'] = document.getElementById('GaCampaign').value;
      zohoData['gclid_field'] = document.getElementById('gclid_field').value;


      xhr.send(JSON.stringify(zohoData))



    }

  }

  getRefQueryParam(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };


  // The "next" and "previous" button functions
  get previousButton(){
    let currentStep = this.state.currentStep;
    return (
      <button
        className="btn btn--yellow btn--auto-width btn--previous"
        type="button"
        onClick={this._prev}
        disabled={ (currentStep!==1) ? '' : 'disabled' }
        >
      <svg className="lollypop" viewBox="0 0 28 12"><path className="path" d="M17,6a5,5,0,1,0,5-5,5,5,0,0,0-5,5H0"/></svg>
      <span>Back</span>
      </button>
    )
  }

  get nextButton(){
    let currentStep = this.state.currentStep
    let maxSteps = this.state.maxSteps
    return (
      (currentStep<maxSteps) ?
      (
        <button
          className="btn btn--yellow btn--auto-width"
          type="button"
          onClick={this._next}
          >
        <span>Next</span>
        <svg className="lollypop" viewBox="0 0 28 12"><path className="path" d="M17,6a5,5,0,1,0,5-5,5,5,0,0,0-5,5H0"/></svg>
        </button>
      )
      : ''
    )
  }
  get submitButton(){
    let currentStep = this.state.currentStep
    let maxSteps = this.state.maxSteps
    let recaptchaComplete = this.state.recaptchaComplete
    return (
      (currentStep < maxSteps) ?
      ''
      : (
        <button
          className="btn btn--yellow btn--auto-width"
          type="submit"
          disabled={(recaptchaComplete) ? '' : true}
          >
        <span>Submit</span>
        <svg className="lollypop" viewBox="0 0 28 12"><path className="path" d="M17,6a5,5,0,1,0,5-5,5,5,0,0,0-5,5H0"/></svg>
        </button>
      )

    )
  }

  updateNotes(event) {
    this.setState({additionalNotes: event.target.value});
  }

  render() {
    console.log("this.state.stepData")
    console.log(this.state.stepData)
    return (
      <section class="master-form">
        <div className="col col--6@xl">

          <Form className="multi-step-form" onSubmit={this._submit}>
          <a href="//data-broker.co.uk" className="logo">
            <img src={ logo } alt="Databroker logo" />
          </a>
          <i className={ (this.state.showInfo) ? 'show-info show-info--cross' : 'show-info' } onClick={ (e) => { this.setState(prevState => ({
  showInfo: !prevState.showInfo
})) } }></i>
          <StepIndicator steps={this.state.stepData} currentStep={this.state.currentStep} stepChange={ this.stepChange } />

            {
              Object
                .keys(this.state.stepData)
                .map( (key, index) => {
                  return (
                    <Step
                      key={key}
                      currentStep={this.state.currentStep}
                      stepNum={index+1}
                      step={this.state.stepData[key]}
                      handleChange={this.handleChange}
                      sliderChange={this.handleSliderChange}
                      personalDetails={this.state.personalDetails}
                      selectedChoices={this.state.selectedChoices}
                      recaptcaChange={this.recaptcaChange}

                    />
                  )
              })
            }

            <div className="notes-group">
              <label>Additional Notes</label>
              <textarea value={this.state.additionalNotes} onChange={this.updateNotes}></textarea>
            </div>


            <footer className="multi-step-form__footer">
              {this.previousButton}
              {this.nextButton}
              {this.submitButton}
            </footer>

          </Form>
        </div>

        <div className="col col--6@xl col--no-pad">
          <div className={ (this.state.showInfo) ? 'quote-form-info-panel quote-form-info-panel--open' : 'quote-form-info-panel' }>
            <p>Prefer an over the phone quote? Just give us a call on <a href="tel:0161 941 5700">0161 941 5700</a> or send us an email at <a href="mailto:hello@data-broker.co.uk">hello@data-broker.co.uk</a>. <a href="//data-broker.co.uk">Click here</a> to Return to the Databroker website</p>
          </div>
          <div className="quote">
            <p className="h3" id="quoteText">
              {
                <span style={{
                  display: (this.state.choiceMade) ? 'inline' : 'none'
                }}>I'm looking for data </span>
              }
              {
                Object
                  .keys(this.state.stepData)
                  .map( (key, index) => {
                    return (
                      <QuoteText
                        key={key}
                        index={index}
                        selectedChoices={this.state.selectedChoices[index]}
                        numberOfChoices={Object.keys(this.state.selectedChoices).length}
                        choiceMade={this.state.choiceMade}
                        prefix={this.state.stepData[key]['content']['quoteTextPrefix']}
                        postfix={this.state.stepData[key]['content']['quoteTextPostfix']}
                        seperator={this.state.stepData[key]['content']['seperator']}
                        valuesLabel={this.state.stepData[key]['content']['valuesTextPrefix']}
                        type={this.state.stepData[key]['content']['type']}
                      />
                    )
                })
              }


            </p>
          </div>
        </div>

        {
          (this.state.completing) ?
            <LoadingSection />
          : ''
        }
        {
          (this.state.complete) ?
            <CompleteSection />
          : ''
        }


      </section>
    )
  }
}

export default withUserAgent(MasterForm);
// export default MasterForm;
